import SidebarPanelContent from 'LayoutBuilderUI/components/panels/sidebar/SidebarPanelContent';
import { jsx as _jsx } from "react/jsx-runtime";
function ContentPanel() {
  return /*#__PURE__*/_jsx(SidebarPanelContent, {});
}
export default ContentPanel;